import { Link } from 'react-router-dom'

import DiscordIcon from '@src/components/icons/DiscordIcon'
import HeadphoneIcon from '@src/components/icons/HeadphoneIcon'
import TelegramIcon from '@src/components/icons/Telegram'
import { STATS } from '@src/configs/paths'

export const AUDIT_LINK = 'https://drive.google.com/file/d/1zwcpFp-Mkjiz9f77Q5oWr8jKrlfwvVmL/view'
export const CONTACT_LINK = 'mailto:support@tristero.xyz'
export const BUG_FORM_LINK =
    'https://docs.google.com/forms/d/1j2jOzuAibZA3-5g84HNYEyG8c8plgkJ1-Nf7_pAnC1Q/viewform?edit_requested=true'
export const FEEDBACK_FORM_LINK = 'https://feedback.mach.exchange/roadmap'
export const TWITTER_LINK = 'https://x.com/mach_exchange'
export const TELEGRAM_LINK = 'https://t.me/mach_exchange'
export const DISCORD_LINK = 'https://discord.gg/mach'
export const SUPPORT_LINK = DISCORD_LINK // Using Discord as support link

const Footer = () => {
    return (
        <footer className='w-full'>
            {/* Desktop Footer */}
            <div className='container hidden items-center justify-between pb-8 pt-6 font-geist md:flex'>
                {/* Left section - Footer links and Copyright */}
                <div className='flex items-center space-x-6 text-white'>
                    <Link to={AUDIT_LINK} target='_blank' className='py-2 !leading-5 hover:text-mach-sub-text'>
                        Audit
                    </Link>
                    <Link to={STATS} className='py-2 !leading-5 text-white hover:text-mach-sub-text'>
                        Stats
                    </Link>
                    <Link to={CONTACT_LINK} className='py-2 !leading-5 hover:text-mach-sub-text'>
                        Contact
                    </Link>
                    <Link to={BUG_FORM_LINK} target='_blank' className='py-2 !leading-5 hover:text-mach-sub-text'>
                        Bugs
                    </Link>
                    <Link to={FEEDBACK_FORM_LINK} target='_blank' className='py-2 !leading-5 hover:text-mach-sub-text'>
                        Feedback
                    </Link>
                    <div className='text-md text-mach-sub-text'>
                        Copyright © {new Date().getFullYear()} Mach Protocol
                    </div>
                </div>

                {/* Right section - Social media icons and Support */}
                <div className='flex items-center space-x-2'>
                    <Link
                        className='flex h-9 w-9 items-center justify-center rounded-md bg-mach-gray transition-all duration-300 hover:brightness-110'
                        to={TWITTER_LINK}
                        target='_blank'
                    >
                        {/* X Logo (formerly Twitter) */}
                        <svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path
                                d='M16.9707 3H19.9649L13.4142 10.4308L21 21H14.8261L10.2981 14.5731L5.09956 21H2.10295L9.09359 13.0538L1.86768 3H8.19209L12.2719 8.86538L16.9707 3ZM15.6574 19.2154H17.2125L7.30016 4.70769H5.63248L15.6574 19.2154Z'
                                fill='currentColor'
                            />
                        </svg>
                    </Link>
                    <Link
                        className='flex h-9 w-9 items-center justify-center rounded-md bg-mach-gray hover:brightness-110'
                        to={TELEGRAM_LINK}
                        target='_blank'
                    >
                        <TelegramIcon className='h-5 w-5' />
                    </Link>
                    <Link
                        className='flex h-9 w-9 items-center justify-center rounded-md bg-mach-gray hover:brightness-110'
                        to={DISCORD_LINK}
                        target='_blank'
                    >
                        <DiscordIcon className='h-5 w-5' />
                    </Link>
                    <Link
                        className='flex h-9 items-center justify-center gap-2 rounded-md bg-mach-gray px-4 py-2 hover:brightness-110'
                        to={SUPPORT_LINK}
                        target='_blank'
                    >
                        {/* Headphone with mic icon */}
                        <HeadphoneIcon className='h-5 w-5' />
                        <span className='text-white'>Support</span>
                    </Link>
                </div>
            </div>
        </footer>
    )
}

export default Footer
